"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var O = __importStar(require("fp-ts/Option"));
var Option_1 = require("fp-ts/Option");
var function_1 = require("fp-ts/function");
var React = __importStar(require("react"));
var FieldFormatter_1 = require("../FieldFormatter");
var FlexView_1 = require("../FlexView");
var TextFormatter_1 = require("../TextFormatter");
require("./progressBar.css");
exports.ProgressBar = React.memo(function (_a) {
    var _b = _a.theme, theme = _b === void 0 ? { type: 'default' } : _b, _c = _a.valueType, valueType = _c === void 0 ? 'percentage' : _c, _d = _a.fractionDigits, fractionDigits = _d === void 0 ? 2 : _d, props = __rest(_a, ["theme", "valueType", "fractionDigits"]);
    var percentage = props.total ? Math.round((props.amount / props.total) * 100) : props.amount;
    var themeScaleO = function () {
        return (0, function_1.pipe)(O.fromNullable(theme), O.filter(function (t) { return t.type === 'scale'; }));
    };
    var calculateStepPercentage = function (i, steps) { return ((i + 1) / steps) * 100; };
    var renderSteps = function () {
        return (0, function_1.pipe)(themeScaleO(), O.map(function (s) {
            return __spreadArray([], Array(s.steps), true).map(function (_, i) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "step", style: { left: "".concat(calculateStepPercentage(i, s.steps), "%") } }, { children: "\u00A0" }), "step-".concat(i))); });
        }), O.toNullable);
    };
    var calculateItemSize = function (steps) {
        return (Math.floor((12 * 2) / steps) / 2);
    };
    var renderStepsLabel = function () {
        return (0, function_1.pipe)(themeScaleO(), (0, Option_1.map)(function (s) {
            return ((0, jsx_runtime_1.jsx)(FlexView_1.FlexView, __assign({ vAlignContent: "center", hAlignContent: "center" }, { children: __spreadArray([], Array(s.steps), true).map(function (_, i) {
                    var _a;
                    return ((0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ xs: calculateItemSize(s.steps) }, { children: (0, jsx_runtime_1.jsx)(TextFormatter_1.TextFormatter, __assign({ fontColor: percentage >= calculateStepPercentage(i, s.steps)
                                ? s.reachedStepColor
                                : 'black', fontSize: (_a = s.reachedStepFontSize) !== null && _a !== void 0 ? _a : 'lg', fontWeight: "semi-bold" }, { children: i + 1 })) }), "step-label-".concat(i)));
                }) })));
        }), O.toNullable);
    };
    var renderLabel = function () {
        return (0, function_1.pipe)(O.fromNullable(props.label), (0, Option_1.map)(function (l) { return (0, jsx_runtime_1.jsx)("span", { children: l }); }), O.toNullable);
    };
    var renderAmountAndTotalValues = function () {
        return (0, function_1.pipe)(O.fromNullable(valueType), (0, Option_1.map)(function (vt) {
            switch (vt) {
                case 'percentage':
                    return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [props.amount, "%"] });
                case 'currency':
                    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(FieldFormatter_1.FieldFormatter.Money, { amount: props.amount, fractionDigits: fractionDigits }), props.total ? renderTotal(props.total) : ''] }));
                case 'numeric':
                    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [props.amount, props.total ? " / ".concat(props.total) : ''] }));
            }
        }), O.toNullable);
    };
    var renderAmountAndTotal = function () {
        return (0, function_1.pipe)(O.fromNullable(theme), O.filter(function (t) { return t.type === 'default'; }), (0, Option_1.map)(function () { return (0, jsx_runtime_1.jsx)("div", __assign({ className: "amount-and-total" }, { children: renderAmountAndTotalValues() })); }), O.toNullable);
    };
    var renderTotal = function (total) {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [' ', "/ ", (0, jsx_runtime_1.jsx)(FieldFormatter_1.FieldFormatter.Money, { amount: total, fractionDigits: fractionDigits })] }));
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, clsx_1.default)('progress-bar', "progress-bar-".concat(props.color), "progress-bar-type-".concat(theme === null || theme === void 0 ? void 0 : theme.type)) }, { children: [renderLabel(), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "progress" }, { children: [(0, jsx_runtime_1.jsx)("div", { className: "level", style: { width: "".concat(Math.min(percentage, 100), "%") } }), renderSteps(), renderStepsLabel(), renderAmountAndTotal()] }))] })));
});
//# sourceMappingURL=ProgressBar.js.map